export type TTemplateTagsFilterOptions = { [k: string]: { text: string, value: string }[] }


export enum ELogErrorMsg {
    //Bee Editor
    ErrorGettingBeeToken = "Error getting bee token",
    ErrorReloadingBeeEditor = "Error reloading bee editor",
    ErrorOnBrandingToggle = "Error onBrandingToggle",

    //Lists
    ErrorFetchingLists = "Error fetching lists",

    //Forms
    ErrorPublishingForm = "Error publishing form",
    ErrorCreatingForm = "Error creating form",
    ErrorSavingForm = "Error saving form",
    ErrorGettingForm = "Error getting form",

    //Zendesk
    ZendeskSupportNotEnabled = "Zendesk support is not enabled, missing help url",

    //Utils
    AccountIdForStoredFilters = "An Account id is required to get stored filters",
}